import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { ENV } from '@app/env';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
export type GamificationModules = 'shopping_cart' | 'notes' | 'questions' | 'polls' | 'networking' | 'shared' | 'referral';

@Injectable()
export class GamificationProvider {

  public clientId = ENV.client;

  constructor(
    private afDatabase: AngularFireDatabase,
    private afStore: AngularFirestore,
  ) { }

  private saveGamificationMetada(clientId: string, userId: string, module, points: number) {
    const key = this.afStore.createId();
    const data = {
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
      user: userId,
      module,
      points
    };
    return this.afStore.collection(clientId).doc('gamification').collection(userId).doc(key)
      .set(data);
  }

  private saveGamificationMetadaUserPartner(clientId: string, userIdPartner: string, userId: string, module, points: number) {
    const key = this.afStore.createId();
    const data = {
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
      user: userIdPartner,
      userAssociated: userId,
      module,
      points
    };
    return this.afStore.collection(clientId).doc('gamification').collection(userIdPartner).doc(key)
      .set(data);
  }

  public getUserPointsMetadataByModule(userId: string, module: string) {
    return this.afStore.collection(ENV.client).doc('gamification').collection(userId, ref =>
      ref.where('module', '==', module))
      .valueChanges()
      .pipe(map(((historyPoints: any[]) => {
        let totalPoints = 0;
        for (let item of historyPoints) {
          totalPoints += item.points
        }
        return totalPoints;
      })));
  }

  private addUserPoints(clientId: string, userId: string, points: number) {
    return this.afDatabase.object(`/Clients/${clientId}/UserStats/${userId}/GamificationPoints`)
      .query.ref.transaction(val => {
        if (val) {
          return parseInt(val) + points;
        } else {
          return 0 + points;
        }
      });
  }

  public getUserPoints(userId: string): Observable<any> {
    return this.afDatabase.object(`/Clients/${ENV.client}/UserStats/${userId}/GamificationPoints`)
      .valueChanges();
  }

  private verifyGamificationPoints(clientId: string, moduleName: string) {
    return this.afDatabase.object(`/Clients/${clientId}/Gamification/${moduleName}`)
      .query.once('value').then(data => data.val());
  }

  public applyPoints(clientId: string, userId: string, module: GamificationModules) {
    this.verifyGamificationPoints(clientId, module)
      .then(value => {
        if (value && value > 0) {
          this.addUserPoints(clientId, userId, parseInt(value))
            .then(() => this.saveGamificationMetada(clientId, userId, module, parseInt(value)));
        }
      });
  }

  public applyPointsPartner(clientId: string, userIdPartner: string, userId: string, module) {
    const normalModule = module;
    const modulePartner = module += '_investor';
    this.verifyGamificationPoints(clientId, modulePartner)
      .then(value => {
        if (value && value > 0) {
          this.addUserPoints(clientId, userIdPartner, parseInt(value))
            .then(() => this.saveGamificationMetadaUserPartner(clientId, userIdPartner, userId, normalModule, parseInt(value)));
        }
      });
  }

  getHistoryUserPoints(userId: string, clientId: string) {
    return this.afStore.collection(clientId).doc('gamification').collection(userId, ref => ref.orderBy('created_at'))
      .valueChanges();
  }

  lastViewPoints(userId: string) {
    this.afDatabase.object(`/Clients/${this.clientId}/Users/${userId}/lastViewNotification`).set(firebase.database.ServerValue.TIMESTAMP);
  }

  getPointsWithoutReview(userId: string, clientId: string) {
    return this.afStore.collection(clientId)
      .doc('gamification')
      .collection(userId)
      .valueChanges();
  }
}


// WEBPACK FOOTER //
// ./src/providers/gamification.ts